import type { TenantConfig } from '@/types/TenantConfig'

const red = '#ED2124'

export const imsmuseum: TenantConfig = {
  logo: 'assets/imsmuseum/static/logo2.png',
  themeOptions: {
    primaryColor: red,
    secondaryColor: red,
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    cartHeaderBackgroundColor: 'black',
    memberLinksColor: 'white',
    memberLinksColorHover: 'white',
    logoHeight: '120px',
    headerHeight: '120px',
    headerBackground: 'black',
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/imsmuseum/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
}
